import React, {Component} from 'react';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {Button, Form, Input, message, Modal, PageHeader, Space, Tag, Tooltip, Typography} from "antd";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;
class RDInvestManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyId:this.props.companyId,
            companyName:this.props.companyName,
            organizationData:[
                {
                    para1:'',
                    time:'',
                    companyName:'',
                }
            ],
            para1:'',
            time:'',
            status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getRDInvestManageQ2, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            organizationData:res.data,
                            para1:res.data.para1,
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:true
                        }))
                    }
                    else{
                        message.info("该材料未填写数据，请填写").then()
                        this.setState(()=>({
                            organizationData:[],
                            status:false
                        }))
                    }
                }
            )
    }
    edit(){
        fetchPost(global.constants.getRDInvestManageQ2, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            para1:res.data.para1,
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:false,
                        }))
                    }
                }
            )
    }
    submit(){
        if(this.state.time === ''||this.state.para1 === ''){
            message.info("请检查信息是否填写完整").then()
        }else{
            let params={
                companyId:this.state.companyId,
                companyName:this.state.companyName,
                para1: this.state.para1,
                time:this.state.time
            }
            fetchPost(global.constants.updateRDInvestManage,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getRDInvestManageQ2, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                organizationData:res.data,
                                                para1:res.data.para1,
                                                time:res.data.time,
                                                companyName:res.data.companyName,
                                                status:true,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    para1Change(e){
        const value = e.target.value
        this.setState(()=>({
            para1:value
        }))
    }
    timeChange(e){
        const value = e.target.value
        this.setState(()=>({
            time:value
        }))
    }
    handleExportClick(){
        let params = {
            companyId:this.state.companyId
        }
        fetchPost(global.constants.exportRDInvestManageQ2,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/研发投入核算管理制度.doc',
            fileName: '研发投入核算管理制度.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '研发投入核算管理制度.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'研发投入核算管理制度.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/研发投入核算管理制度.pdf',
                            fileName: '研发投入核算管理制度.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发投入核算管理制度',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'研发投入核算管理制度',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','研发投入核算管理制度');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'研发投入核算管理制度',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发投入核算管理制度',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="研发投入核算管理制度"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <div className="content-frame-wordStyle">
                    <div className="content-form-wordStyle">
                        <Space direction="vertical" >
                            <Typography>
                                <Paragraph className="word">
                                    <Paragraph className="word-title">研发投入核算管理制度</Paragraph>
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    一、研发项目立项及成果报告
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1、研发部负责研发创新工作的全面工作。
                                    {
                                        this.state.status === false?
                                            <Input
                                                defaultValue={this.state.organizationData.para1}
                                                className="input_style"
                                                onChange={this.para1Change.bind(this)}
                                            />:
                                            this.state.organizationData.para1
                                    }
                                    在整个开发过程中给予支持和配合。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2、研发创新项目是指“不重复的，具有独立时间、财务安排和人员配置的研究开发活动”。
                                    立项要符合国家和青岛市的技术政策和产业政策，符合《国家重点支持的高新技术领域》。
                                    是为获得科学与技术新知识，创造性运用科学技术新知识，或实质性改进技术、工艺、
                                    产品而持续进行的具有明确目标的研发创新活动。不包括对产品的常规升级或对公开科研成果直接应用。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3、研发创新内容和目标
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （一）项目主要内容及关键技术
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （二）研发创新项目的创新点
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （三）主要技术指标或收益指标等
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.1、费用预算情况，包括
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （1）人员人工：研发人员全年工资薪金，包括基本工资、奖金、补贴、年终加薪、加班工资以及与其任职或者受雇有关的其他支出。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （2）直接投入：为实施研究开发项目而购买的原材料等相关支出。
                                    包括：原材料、水电；用于中间试验和产品试制达不到固定资产标准的模具、
                                    样品及一般测试手段购置费、试制产品的检验费等；用于研究开发活动的仪器
                                    设备的简单维护费；以经营租赁方式租入的固定资产发生的租赁费等。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （2）直接投入：为实施研究开发项目而购买的原材料等相关支出。
                                    包括：原材料、水电；用于中间试验和产品试制达不到固定资产标准的模具、样品及一般测试手段购置费、
                                    试制产品的检验费等；用于研究开发活动的仪器设备的简单维护费；以经营租赁方式租入的固定资产发生的租赁费等。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （4）设计费用：为新产品和新工艺的构思、开发和制造，进行工序、技术规范、
                                    操作特性方面的设计等发生的费用。新产品设计费、新工艺规程制定费
                                    以及与研发活动直接相关的技术图书资料费、资料翻译费。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （5）装备调试费：主要包括工装准备过程中研究开发活动所发生的费用
                                    （如研制生产机器、模具和工具，改变生产和质量控制程序，或制定新方法及标准等）。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （6）无形资产摊销：因研究开发活动需要购入的专有技术
                                    （包括专利、非专利发明、许可证、专有技术、设计和计算方法等）所发生的费用摊销。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （7）委托外部研究开发费用：是指委托境内其他企业、大学、研究机构、技术专业服务机
                                    构和境外机构进行研究开发活动所发生的费用（项目成果为企业拥有，且与企业的主要经营业务紧密相关）。
                                    委托外部研究开发费用的发生金额应按照独立交易原则确定。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （8）其他费用：为研究开发活动所发生的其他费用，如办公费、
                                    通讯费、专利申请维护费、高新科技研发保险费研发成果的论证、评审、验收费用等。此项费用一般不得超过研究开发总费用的10％。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.2、各项目现有专用设备、固定资产及需新增设备、固定资产也应在计划书中列明。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4、审批立项计划书，形成立项决议：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4.1立项决议及立项计划书经批准后，应报送财务部备案。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4.2所有研发项目的启动、暂停、终止都须经总经理、财务部审批。项目组人员、设备变动须报财务部备案。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    二、研究开发费用归集
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1、研究开发经费是用于进行科学技术研究、开发、新技术推广应用的专项费用，必须按计划专项管理，统筹安排，节约使用。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2、研究开发经费的来源：政府的专项科技基金拨款；公司自筹研究开发项目资金；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3、研究开发经费的管理
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.1公司应根据研究开发项目的立项报告建立研究开发费用专项明细账，
                                    准确、及时地归集各个项目的费用发生情况。多个研发项目使用共同资源的，
                                    应采用科学合理的方法将研发费用在各个受益项目之间分摊。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.2公司研发部是研究开发经费的归口管理部门，具体负责研究开发费用的签批、核定；
                                    公司财务部是研究开发经费的归集、核算、记帐、监督部门，研究开发经费实行专款专用，严格管理。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.3研究开发经费的拨付在研究开发项目立项决议审批后才能启用，
                                    并由项目负责人按规定的使用范围严格控制、合理使用。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.4研究开发有关内容需要与外单位合作或委托其进行的，
                                    必须签订科研项目外委技术合作研究合同，该合同须由公司研发中心审查后才能生效。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.5研究开发经费报销时，须由项目负责人、总经理审核签批，
                                    并在核销票据上注明所属项目后方可到财务核销；所有新产品领料，
                                    不论是研发中心还是生产、技术质量组门，只要是用于新产品的材料必须由研发部调度签批，注明所属项目后方可领取。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.6研究开发经费一律不进入本单位产品成本，在管理费用中列支，月
                                    末仓库原材料耗用表中根据新产品领用材料金额在表中单独列明，领料单单独附后。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.7各项目因研究开发工作需要，购置2000元以上设备、仪器者，须列入该项目专用固定资产，项目完成后办理有关转资手续。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.8财务部应每季度对研究开发费进行汇总分析，包括金额及占收入的比例，
                                    如未按计划执行或比例未达到高新技术企业规定标准，应及时通知相关部门进行调整。
                                    公司的年度财务会计报告须披露研究开发费用的相关财务信息，包括研究开发费用支出额度及其占销售收入的比例情况等。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3.9对于研究开发经费的使用情况，公司将组织适时审查，如发现经费使用不当的，
                                    要追究项目负责人的责任，并视具体情况，收回项目计划安排的投资款项。
                                </Paragraph>
                                <div style={{float:'right',marginRight:'10%'}}>
                                    <Paragraph className="textStyle">
                                        {this.state.companyName}
                                    </Paragraph>
                                    <Paragraph className="textStyle">
                                        {
                                            this.state.status === false?
                                                <Input
                                                    placeholder={'请填写文件时间'}
                                                    defaultValue={this.state.organizationData.time}
                                                    className="input_style"
                                                    onChange={this.timeChange.bind(this)}
                                                />:
                                                this.state.organizationData.time
                                        }
                                    </Paragraph>
                                </div>
                            </Typography>
                            <div>
                                <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                                <Button
                                    disabled={!this.state.status}
                                    type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                            </div>
                        </Space>
                        <Modal
                            visible={this.state.preview_visible}
                            title={'预览'}
                            onCancel={this.hideModal}
                            destroyOnClose
                            width={'50%'}
                            footer={[
                                <Button key="back" onClick={this.hideModal}>
                                    取消
                                </Button>,
                                <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                    下载
                                </Button>,
                            ]}
                        >
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                        </Modal>
                        <Modal
                            visible={this.state.upload_visible}
                            title={'上传附件'}
                            onCancel={this.hideModal.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModal.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                                    完成
                                </Button>,
                            ]}
                        >
                            <div>
                                该公司的研发投入核算管理制度
                                {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                                <Form style={{marginTop:'20px'}}>
                                    <Form.Item
                                        name='file'
                                        method="post"
                                        enctype="multipart/form-data"
                                    >
                                        <input
                                            type="file"
                                            name='file'
                                            onChange={this.fileInput.bind(this)}
                                        />
                                    </Form.Item>
                                    <Form.Item name="preview_paper">
                                        {
                                            this.state.checkStatus === true &&
                                            <div>
                                                <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                                <FileViewer fileType='pdf'
                                                            filePath={this.state.fileStream_upload}
                                                            onError={this.onError}
                                                />
                                            </div>
                                        }
                                    </Form.Item>
                                </Form>
                            </div>
                        </Modal>
                        <Modal
                            visible={this.state.uploadFile_visible}
                            title={'上传'}
                            onCancel={this.hideModalTwo.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                                    确定
                                </Button>,
                            ]}
                        >
                            <div>确定上传该研发投入核算管理制度吗？</div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default RDInvestManage;